/**
 * DevExtreme (esm/__internal/core/r1/utils/get_computed_style.js)
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import { getWindow } from "../../../../core/utils/window";
export default function getElementComputedStyle(el) {
  var _window$getComputedSt;
  const window = getWindow();
  return el ? null === (_window$getComputedSt = window.getComputedStyle) || void 0 === _window$getComputedSt ? void 0 : _window$getComputedSt.call(window, el) : null;
}